import type {RouteRecordRaw} from "vue-router";
import {canAccess, permissionList} from "@/utilities/authorization";

const settingRoutes: RouteRecordRaw[] = [
    {
        name: 'setting',
        path: '/setting',
        component: () => import('@/views/setting/SettingDashboard.vue'),
    },
    {
        name: 'account-profile',
        path: '/setting/account-profile',
        component: () => import('@/views/setting/AccountProfile.vue'),
    },
    {
        name: 'change-password',
        path: '/setting/account-profile/change-password',
        component: () => import('@/views/setting/ChangePassword.vue'),
    },
    {
        name: 'company-profile',
        path: '/setting/company-profile',
        component: () => import('@/views/setting/CompanyProfile.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER),
    },
    {
        name: 'company-update',
        path: '/setting/company-profile/update',
        component: () => import('@/views/setting/UpdateCompany.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER),
    },
    {
        name: 'subscription',
        path: '/setting/subscription',
        component: () => import('@/views/setting/subscription/SubscriptionDashboard.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER),
    },
    {
        name: 'buy-subscription',
        path: '/setting/subscription/buy/:id(\\d+)',
        component: () => import('@/views/setting/subscription/BuySubscription.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER),
    },
]

export default settingRoutes